import { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import { AgGridReact } from 'ag-grid-react';
import { OutlinedInput, InputAdornment, FormControl, Grid } from '@mui/material';

// Para traduccion
// import {AG_GRID_LOCALE_ES} from 'translations/index.js';

const CustomTableData = (props) => {

    const {
        
        // datos (listados, individuales)
        rowConfig,
        columnConfig,

        // Estilo
        customHeight,

        // Para desabilitar la bara de busqueda
        disableSearchBar = false,
        gridOptions = {},

    } = props



    // Hook: para poder filtrar datos de la tabla
    const gridRef = useRef();

    // Hook: Para definir un array que se usara para listar la informacion de la BD
    const [rowData, setRowData] = useState([]);

    // Hook: Para definir un array que se usara para configurar los encabezados de columna
    const [colDefs, setColDefs] = useState(columnConfig);

    // Hook: Para distribuir las columnas en toda la tabla
    const autoSizeStrategy = useMemo(() => {
        return {
            type: 'fitGridWidth',
            defaultMinWidth: 100,
        };
    }, []);

    // Hook: Para filtrar por cualquier columna de la tabla
    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            'quickFilterText',
            document.getElementById('filtro').value
        );
    }, []);

    // Se settea la información en donde corresponde
    useEffect(() => {
        
        // setColDefs([...headersTable])
        setRowData([...rowConfig])

    }, [rowConfig]);

    // Se settea la información en donde corresponde
    useEffect(() => {
        
        setColDefs([...columnConfig])

    }, [columnConfig]);

    const defaultHeight = {
        height: '60vh',
        margin: 0
    }

  return (
    //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
    <>
      {!disableSearchBar && (
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl fullWidth>
              <OutlinedInput
                id='filtro'
                name='filtro'
                onInput={onFilterTextBoxChanged}
                size='small'
                type="text"
                startAdornment={
                  <InputAdornment position="start">
                    <i className="fa-solid fa-magnifying-glass"></i>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
        </Grid>
      )}

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className="ag-theme-quartz" style={customHeight ? customHeight : defaultHeight}>
            {/* The AG Grid component */}
            <AgGridReact
              ref={gridRef}//PROPIEDAD PARA PERMITIR FILTRAR EN LA TABLA
              gridOptions={gridOptions}
              rowData={rowData}
              columnDefs={colDefs}
              pagination={true}
              paginationAutoPageSize={true}//PROPIEDAD PARA COLOCAR CANTIDAD DE FILAS QUE PERMITA EL TAMAÑO DE PANTALLA 
              autoSizeStrategy={autoSizeStrategy}//PROPIEDAD PARA QUE LAS COLUMNAS LLENEN TODA LA TABLA
              enableCellTextSelection={true}
            // localeText={AG_GRID_LOCALE_ES}
            />

          </div>
        </Grid>
      </Grid>
    </>
  )
}

export {
    CustomTableData
}